/* eslint-disable no-param-reassign */
import { getItem, setItem } from './LocalStorage';

// Check token expiration date before all requests, generates a new one if it has expired
// or if you only have two minutes before that happens.

const checkTokenOrDispatch = (
  flagsByType,
  tokenType,
  token,
  prefixUrl,
  tokenIsExpired,
  config,
  refreshToken,
  headers,
  credentials,
) => {
  // Mark an ongoing request
  flagsByType[tokenType] = true;

  // If no request is being made, please check the token of this request
  if (tokenIsExpired(token) && prefixUrl) {
    // If not valid, please refresh, update the token and call the API
    // Get a new token from the API and when ready re-lunch the request with it
    return refreshToken(`${prefixUrl}/api/signIn/refresh`, { refreshToken: token }, {
      headers,
      credentials,
    }, tokenType)
      .then((newToken) => {
        setItem('API_TOKEN', newToken);
        config.headers.Authorization = newToken;
        return Promise.resolve(config);
      })
      .catch((error) => Promise.reject(error));
  }

  // If the token is valid please call the API
  config.headers.Authorization = token;
  return Promise.resolve(config);
};

export const requestInterceptor = (axiosInstance, getUrlDomain, tokenIsExpired, refreshToken, flagsByType, queue) => (
  axiosInstance.interceptors.request.use((config) => {
    const {
      url,
      headers,
      credentials,
    } = config;
    const token = getItem('API_TOKEN');
    const prefixUrl = getUrlDomain(url);
    const tokenType = 'request';

    // Do we have an ongoing request?
    if (flagsByType[tokenType]) {
      // If we do, please put this one in the queue
      return new Promise((resolve, reject) => {
        queue.push({ resolve, reject });
      })
        // Try dispatching the queued request with a new token (presumably new)
        .then((refreshedToken) => (
          checkTokenOrDispatch(
            flagsByType,
            tokenType,
            refreshedToken,
            prefixUrl,
            tokenIsExpired,
            config,
            refreshToken,
            headers,
            credentials,
          )))
        .catch((err) => err);
    }

    return checkTokenOrDispatch(
      flagsByType,
      tokenType,
      token,
      prefixUrl,
      tokenIsExpired,
      config,
      refreshToken,
      headers,
      credentials,
    );
  }, (error) => Promise.reject(error)));

export default {
  requestInterceptor,
};
